<template>
  <div class="frisbuy-gallery-pagination">
    <span
      v-for="paginationItemIdx in paginationItems"
      :key="paginationItemIdx"
      @click="$emit('navigateTo', paginationItemIdx)"
      class="frisbuy-gallery-page"
      :class="{
        active: paginationItemIdx == currentItemIdx,
        'frisbuy-video-play': isPlaying,
      }"
    ></span>
  </div>
</template>

<style scoped lang="scss">
.frisbuy-gallery-pagination {
  display: flex;
  position: relative!important;
  bottom: 0!important;
  justify-content: center;
  align-items: center;
  width: 100%;

  &__counter {
    color: #a9a9ae;
    font-size: 12px;

    min-width: fit-content;

    margin-left: 16px;
  }

  .frisbuy-gallery-page {
    width: 10px;
    aspect-ratio: 1 / 1;
    border-radius: 50%;
    background-color: #BFBFBF!important;
    opacity: 1;
    margin: 0;
    box-shadow:unset!important;

    &:not(:first-of-type) {
      margin-left: 13px;
    }
   
    &:hover,
    &.active {
      background-color: #DD5393!important;
      opacity: 1;
    }

    &:not(.active) {
      cursor: pointer;
    }

    &.frisbuy-video-play {
      display: none;
    }
  }
}
</style>

<script>
export default {
  data() {
    return {
      /*
        IDK: why the `isPlaying` parameter?
      */
      isPlaying: false,
    };
  },

  props: {
    currentItemIdx: {
      type: Number,
      require: true,
    },

    itemsCount: {
      type: Number,
      require: true,
    },
  },

  emits: ["navigateTo"],

  computed: {
    paginationItems() {
      return Array.from(Array(this.itemsCount).keys());
    },
  },
};
</script>
